module.exports = __webpack_public_path__ + "img/mbs_logo.e4ffa819.png";